import { getConfig } from '@shared/lib/config';

import type { CreateClientConfig } from './generated/client.gen';

/**
 * Базовая конфигурация сгенерированного axios-клиента.
 *
 * `baseURL` берём из рантайм-конфига (см. `shared/lib/config.ts`).
 * `withCredentials: true` нужен для будущего варианта с httpOnly-cookie на refresh-токен.
 *
 * `throwOnError: true` — обязательно: hey-api по умолчанию НЕ кидает исключение
 * на 4xx/5xx, а возвращает объект с полем `error`. Это ломает `try/catch`-логику
 * во всех вызывающих местах (LoginPage, authProvider, http-client.performRefresh,
 * react-query mutationFn). Переключение в throw приводит поведение SDK к
 * ожиданиям остального кода.
 */
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseURL: getConfig().apiBaseUrl,
  withCredentials: true,
  throwOnError: true,
});
